<template>
    <ProcColumnPanel
        title="Documentação anterior"
        :subtitle="`${documentos.length} registro(s)`"
        :expanded="expanded"
        @toggle-expand="$emit('toggle-expand')"
    >
        <div v-if="documentos.length === 0" class="empty-box">
            Nenhum documento anterior localizado para este processo.
        </div>

        <div
            v-for="doc in documentos"
            :key="`${doc.idppe || 'ppe0'}-${doc.idppt || 'ppt0'}-${doc.idreferencia || doc.idanexo}`"
            class="proc-card"
        >
            <div class="card-main">
                <div class="card-text">
                    <h4>{{ doc.nmreferencia }}</h4>
                    <p>{{ doc.nmetapa || 'Etapa não informada' }}</p>
                </div>

                <span :class="['status-pill', statusAnaliseClasse(doc)]">
                    {{ statusAnaliseTexto(doc) }}
                </span>
            </div>

            <div class="tag-row">
                <span class="tag">{{ doc.idppe ? 'Formulário interno' : 'Anexo externo' }}</span>
                <span v-if="doc.analise_dh" class="tag">Analisado em {{ formatarDataHora(doc.analise_dh) }}</span>
                <span v-if="doc.removido_dh" class="tag obrigatorio">Removido</span>
            </div>

            <div v-if="doc.analise_justificativa" class="proc-doc-justificativa">
                {{ doc.analise_justificativa }}
            </div>

            <div class="card-actions">
                <button
                    v-if="doc.idanexo"
                    class="btn-small proc-btn"
                    type="button"
                    @click="$emit('visualizar-anexo', doc.idanexo)"
                >
                    Visualizar
                </button>

                <button
                    v-if="podeAnalisar"
                    class="btn-small proc-btn primary"
                    type="button"
                    @click="$emit('analisar', doc)"
                >
                    Analisar
                </button>
            </div>
        </div>
    </ProcColumnPanel>
</template>

<script setup>
import ProcColumnPanel from './ProcColumnPanel.vue';

defineProps({
    documentos: { type: Array, default: () => [] },
    podeAnalisar: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    formatarDataHora: { type: Function, required: true },
    statusAnaliseTexto: { type: Function, required: true },
    statusAnaliseClasse: { type: Function, required: true },
});

defineEmits(['visualizar-anexo', 'analisar', 'toggle-expand']);
</script>
